import { ISalesTeam } from '@user/store/salesTeam/typings'
import { IFormikSalesTeamAssignment } from '../typings'

export interface ISalesTeamAssignment {
  salesTeamId: number | null
  salesTeamPositionId: number | null
}
interface ISalesTeamMapping {
  salesTeamName: string
  salesTeamId: string
  salesTeamPositionId: string
}

export const getSalesTeamPositions = (
  salesTeamPositionIds: number[] | undefined,
  salesTeams: ISalesTeam[],
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => void,
) => {
  const getSalesTeamAssignments = (): IFormikSalesTeamAssignment[] => {
    const mappings: ISalesTeamMapping[] = []
    if (salesTeamPositionIds) {
      salesTeamPositionIds.map((positionId) => {
        const salesTeam = salesTeams.find(
          (s) => s.positions.findIndex((p) => p.id == positionId) !== -1,
        )
        if (salesTeam) {
          mappings.push({
            salesTeamName: salesTeam.name,
            salesTeamId: salesTeam.id.toString(),
            salesTeamPositionId: positionId.toString(),
          })
        }
      })
    }

    const output: IFormikSalesTeamAssignment[] = mappings
      .sort((a, b) => a.salesTeamName.localeCompare(b.salesTeamName))
      .map<IFormikSalesTeamAssignment>((m: ISalesTeamMapping) => {
        return {
          salesTeamId: m.salesTeamId,
          salesTeamPositionId: m.salesTeamPositionId,
        }
      })

    return output
  }
  if (salesTeamPositionIds && salesTeamPositionIds.length > 0) {
    setFieldValue('salesTeamAssignments', getSalesTeamAssignments())
  } else {
    setFieldValue('salesTeamAssignments', [])
  }
}
